class ComplainDetails {
  constructor() {

    if(document.querySelector('.complain-details') != null && document.querySelector('.complain-details') != undefined) {
      this.setEvents();
    }
  }

  setEvents() {  

    var acc = document.getElementsByClassName("accordion__top");
    var i;

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function(e) {
        e.preventDefault();
        var panel = this.nextElementSibling;
        var filter = this.parentNode;
        if (filter.classList.contains('active')) {
          panel.style.maxHeight = 0;
          filter.classList.toggle("active");
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
          filter.classList.toggle("active");
        };
      });
    };

    // contador de caracteres do textarea

    var reply = document.querySelectorAll('.complain-details__reply');

    if(reply != null && reply != undefined) {
      reply.forEach(r => {
        var textarea = r.querySelector('textarea');
        var maxLength = textarea.getAttribute('maxLength');
        var counter = r.querySelector('.counter__number');
  
        textarea.addEventListener("keyup", function() {
          var text = textarea.value.length;
          counter.textContent = (maxLength - text);
        });
      });
    }

  };

};

$(document).ready(function() {
  const complainDetails = new ComplainDetails();
});
